<template>
  <div class="popup-modal">
    <div class="popup-modal__inner">
      <CloseIcon @click="$emit('close-modal')" class="popup-modal__close" />
      <div class="popup-modal__content-wrapper">
        <div class="popup-modal__content">
          <div class="popup-modal__title">{{ title }}</div>
          <div class="popup-modal__message" v-html="content"></div>
        </div>
        <div class="popup-modal__actions">
          <button class="btn btn--primary" @click="$emit('close-modal')">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api'
import CloseIcon from '@/assets/icons/close_modal_x.svg'

export default defineComponent({
  name: 'PopupModal',
  components: {
    CloseIcon: { ...CloseIcon, name: 'CloseIcon' },
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: true,
    },
  },
})
</script>

<style lang="scss" scoped>
.popup-modal {
  background: var(--gray-gray-2, #222);
  position: absolute;
  max-width: 432px;
  border-radius: 8px;
  @include desktop {
    width: 432px;
  }
  &__inner {
    background: var(
      --glass-mid-gray,
      linear-gradient(105deg, rgba(62, 63, 73, 0.7) -13.91%, rgba(62, 63, 73, 0) 100.48%)
    );
    border-radius: 10px;
    display: flex;
    padding: 20px;
    flex-direction: column;
    align-items: flex-end;
    align-self: stretch;
  }
  &__content-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-end;
    gap: 20px;
    align-self: stretch;
  }
  &__close {
    opacity: 0.7;
    &:hover {
      cursor: pointer;
      opacity: 1;
    }
    &:active {
      opacity: 0.4;
    }
  }
  &__title {
    align-self: stretch;
    color: var(--white, #fff);
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 133.333% */
    margin-bottom: 5px;
  }
  &__message {
    color: var(--light-blue-gray, #afb0bf);
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: 14px;
    font-style: normal;
    font-weight: 450;
    line-height: 20px; /* 142.857% */
  }
}
</style>
